import React from "react";
import Banner from "../components/Banner";
import LogInSection from "../components/LogInSection";
import { useSelector } from "react-redux";

const LogInPage = () => {
  const screen = useSelector((state) => state.userReducer.screen);

  return (
    <div className="LogInPage"> 
        {screen.desktop && (<Banner />)}
        <LogInSection/>
    </div>
  );
};

export default LogInPage;
